import React, { Component } from 'react';
import { ListingForm } from './Form';
import { Spin } from 'antd';
import { inject, observer } from 'mobx-react';

@inject('store')
@observer
export class EditListingView extends Component {
    constructor(props) {
        super(props);

        this.state = { listing: null };
    }

    async componentDidMount() {
        try {
            const { data } = await this.props.store.stratCenter.getUserListing(
                this.props.match.params.id
            );
            this.setState({ listing: data.listing });
        } catch (e) {}
    }

    render() {
        if (!this.state.listing)
            return (
                <div style={{ padding: 50, textAlign: 'center' }}>
                    <Spin size={'large'} tip={'Loading...'} />
                </div>
            );
        return <ListingForm title={'Edit Listing'} edit data={this.state.listing} />;
    }
}



// WEBPACK FOOTER //
// ./src/Account/StratCenter/Edit.js